import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const taskTagsImporterSelectors = importerSelectors(
  'taskTags.importer',
)

export default taskTagsImporterSelectors
